/* eslint-disable max-lines */
/* stylelint-disable */
// 9fbef606107a605d69c0edbcd8029e5d
import { createGlobalStyle } from 'styled-components';

export const CloudinaryVideoPlayerGlobalStyle = createGlobalStyle`
.vjs-modal-dialog .vjs-modal-dialog-content, .video-js .vjs-modal-dialog, .vjs-button > .vjs-icon-placeholder:before, .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.vjs-button > .vjs-icon-placeholder:before, .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
  text-align: center;
}

@font-face {
  font-family: VideoJS;
  src: url(data:application/font-woff;charset=utf-8;base64,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) format("woff");
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-play, .video-js .vjs-play-control .vjs-icon-placeholder, .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-play:before, .video-js .vjs-play-control .vjs-icon-placeholder:before, .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
  content: "\f101";
}

.vjs-icon-play-circle {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-play-circle:before {
  content: "\f102";
}

.vjs-icon-pause, .video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-pause:before, .video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder:before {
  content: "\f103";
}

.vjs-icon-volume-mute, .video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-volume-mute:before, .video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder:before {
  content: "\f104";
}

.vjs-icon-volume-low, .video-js .vjs-mute-control.vjs-vol-1 .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-volume-low:before, .video-js .vjs-mute-control.vjs-vol-1 .vjs-icon-placeholder:before {
  content: "\f105";
}

.vjs-icon-volume-mid, .video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-volume-mid:before, .video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder:before {
  content: "\f106";
}

.vjs-icon-volume-high, .video-js .vjs-mute-control .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-volume-high:before, .video-js .vjs-mute-control .vjs-icon-placeholder:before {
  content: "\f107";
}

.vjs-icon-fullscreen-enter, .video-js .vjs-fullscreen-control .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-fullscreen-enter:before, .video-js .vjs-fullscreen-control .vjs-icon-placeholder:before {
  content: "\f108";
}

.vjs-icon-fullscreen-exit, .video-js.vjs-fullscreen .vjs-fullscreen-control .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-fullscreen-exit:before, .video-js.vjs-fullscreen .vjs-fullscreen-control .vjs-icon-placeholder:before {
  content: "\f109";
}

.vjs-icon-square {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-square:before {
  content: "\f10a";
}

.vjs-icon-spinner {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-spinner:before {
  content: "\f10b";
}

.vjs-icon-subtitles, .video-js .vjs-subs-caps-button .vjs-icon-placeholder,
.video-js.video-js:lang(en-GB) .vjs-subs-caps-button .vjs-icon-placeholder,
.video-js.video-js:lang(en-IE) .vjs-subs-caps-button .vjs-icon-placeholder,
.video-js.video-js:lang(en-AU) .vjs-subs-caps-button .vjs-icon-placeholder,
.video-js.video-js:lang(en-NZ) .vjs-subs-caps-button .vjs-icon-placeholder, .video-js .vjs-subtitles-button .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-subtitles:before, .video-js .vjs-subs-caps-button .vjs-icon-placeholder:before,
.video-js.video-js:lang(en-GB) .vjs-subs-caps-button .vjs-icon-placeholder:before,
.video-js.video-js:lang(en-IE) .vjs-subs-caps-button .vjs-icon-placeholder:before,
.video-js.video-js:lang(en-AU) .vjs-subs-caps-button .vjs-icon-placeholder:before,
.video-js.video-js:lang(en-NZ) .vjs-subs-caps-button .vjs-icon-placeholder:before, .video-js .vjs-subtitles-button .vjs-icon-placeholder:before {
  content: "\f10c";
}

.vjs-icon-captions, .video-js:lang(en) .vjs-subs-caps-button .vjs-icon-placeholder,
.video-js:lang(fr-CA) .vjs-subs-caps-button .vjs-icon-placeholder, .video-js .vjs-captions-button .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-captions:before, .video-js:lang(en) .vjs-subs-caps-button .vjs-icon-placeholder:before,
.video-js:lang(fr-CA) .vjs-subs-caps-button .vjs-icon-placeholder:before, .video-js .vjs-captions-button .vjs-icon-placeholder:before {
  content: "\f10d";
}

.vjs-icon-chapters, .video-js .vjs-chapters-button .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-chapters:before, .video-js .vjs-chapters-button .vjs-icon-placeholder:before {
  content: "\f10e";
}

.vjs-icon-share {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-share:before {
  content: "\f10f";
}

.vjs-icon-cog {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-cog:before {
  content: "\f110";
}

.vjs-icon-circle, .vjs-seek-to-live-control .vjs-icon-placeholder, .video-js .vjs-volume-level, .video-js .vjs-play-progress {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-circle:before, .vjs-seek-to-live-control .vjs-icon-placeholder:before, .video-js .vjs-volume-level:before, .video-js .vjs-play-progress:before {
  content: "\f111";
}

.vjs-icon-circle-outline {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-circle-outline:before {
  content: "\f112";
}

.vjs-icon-circle-inner-circle {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-circle-inner-circle:before {
  content: "\f113";
}

.vjs-icon-hd {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-hd:before {
  content: "\f114";
}

.vjs-icon-cancel, .video-js .vjs-control.vjs-close-button .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-cancel:before, .video-js .vjs-control.vjs-close-button .vjs-icon-placeholder:before {
  content: "\f115";
}

.vjs-icon-replay, .video-js .vjs-play-control.vjs-ended .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-replay:before, .video-js .vjs-play-control.vjs-ended .vjs-icon-placeholder:before {
  content: "\f116";
}

.vjs-icon-facebook {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-facebook:before {
  content: "\f117";
}

.vjs-icon-gplus {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-gplus:before {
  content: "\f118";
}

.vjs-icon-linkedin {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-linkedin:before {
  content: "\f119";
}

.vjs-icon-twitter {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-twitter:before {
  content: "\f11a";
}

.vjs-icon-tumblr {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-tumblr:before {
  content: "\f11b";
}

.vjs-icon-pinterest {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-pinterest:before {
  content: "\f11c";
}

.vjs-icon-audio-description, .video-js .vjs-descriptions-button .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-audio-description:before, .video-js .vjs-descriptions-button .vjs-icon-placeholder:before {
  content: "\f11d";
}

.vjs-icon-audio, .video-js .vjs-audio-button .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-audio:before, .video-js .vjs-audio-button .vjs-icon-placeholder:before {
  content: "\f11e";
}

.vjs-icon-next-item {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-next-item:before {
  content: "\f11f";
}

.vjs-icon-previous-item {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-previous-item:before {
  content: "\f120";
}

.vjs-icon-picture-in-picture-enter, .video-js .vjs-picture-in-picture-control .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-picture-in-picture-enter:before, .video-js .vjs-picture-in-picture-control .vjs-icon-placeholder:before {
  content: "\f121";
}

.vjs-icon-picture-in-picture-exit, .video-js.vjs-picture-in-picture .vjs-picture-in-picture-control .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-picture-in-picture-exit:before, .video-js.vjs-picture-in-picture .vjs-picture-in-picture-control .vjs-icon-placeholder:before {
  content: "\f122";
}

.video-js {
  display: block;
  vertical-align: top;
  box-sizing: border-box;
  color: #fff;
  background-color: #000;
  position: relative;
  padding: 0;
  font-size: 10px;
  line-height: 1;
  font-weight: normal;
  font-style: normal;
  font-family: Arial, Helvetica, sans-serif;
  word-break: initial;
}
.video-js:-moz-full-screen {
  position: absolute;
}
.video-js:-webkit-full-screen {
  width: 100% !important;
  height: 100% !important;
}

.video-js[tabindex="-1"] {
  outline: none;
}

.video-js *,
.video-js *:before,
.video-js *:after {
  box-sizing: inherit;
}

.video-js ul {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  list-style-position: outside;
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
}

.video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 {
  width: 100%;
  max-width: 100%;
  height: 0;
}

.video-js.vjs-16-9 {
  padding-top: 56.25%;
}

.video-js.vjs-4-3 {
  padding-top: 75%;
}

.video-js.vjs-fill {
  width: 100%;
  height: 100%;
}

.video-js .vjs-tech {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

body.vjs-full-window {
  padding: 0;
  margin: 0;
  height: 100%;
}

.vjs-full-window .video-js.vjs-fullscreen {
  position: fixed;
  overflow: hidden;
  z-index: 1000;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.video-js.vjs-fullscreen:not(.vjs-ios-native-fs) {
  width: 100% !important;
  height: 100% !important;
  padding-top: 0 !important;
}

.video-js.vjs-fullscreen.vjs-user-inactive {
  cursor: none;
}

.vjs-hidden {
  display: none !important;
}

.vjs-disabled {
  opacity: 0.5;
  cursor: default;
}

.video-js .vjs-offscreen {
  height: 1px;
  left: -9999px;
  position: absolute;
  top: 0;
  width: 1px;
}

.vjs-lock-showing {
  display: block !important;
  opacity: 1;
  visibility: visible;
}

.vjs-no-js {
  padding: 20px;
  color: #fff;
  background-color: #000;
  font-size: 18px;
  font-family: Arial, Helvetica, sans-serif;
  text-align: center;
  width: 300px;
  height: 150px;
  margin: 0px auto;
}

.vjs-no-js a,
.vjs-no-js a:visited {
  color: #66A8CC;
}

.video-js .vjs-big-play-button {
  font-size: 3em;
  line-height: 1.5em;
  height: 1.63332em;
  width: 3em;
  display: block;
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 0;
  cursor: pointer;
  opacity: 1;
  border: 0.06666em solid #fff;
  background-color: #2B333F;
  background-color: rgba(43, 51, 63, 0.7);
  -webkit-border-radius: 0.3em;
  -moz-border-radius: 0.3em;
  border-radius: 0.3em;
  -webkit-transition: all 0.4s;
  -moz-transition: all 0.4s;
  -ms-transition: all 0.4s;
  -o-transition: all 0.4s;
  transition: all 0.4s;
}
.vjs-big-play-centered .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-top: -0.81666em;
  margin-left: -1.5em;
}

.video-js:hover .vjs-big-play-button,
.video-js .vjs-big-play-button:focus {
  border-color: #fff;
  background-color: #73859f;
  background-color: rgba(115, 133, 159, 0.5);
  -webkit-transition: all 0s;
  -moz-transition: all 0s;
  -ms-transition: all 0s;
  -o-transition: all 0s;
  transition: all 0s;
}

.vjs-controls-disabled .vjs-big-play-button,
.vjs-has-started .vjs-big-play-button,
.vjs-using-native-controls .vjs-big-play-button,
.vjs-error .vjs-big-play-button {
  display: none;
}

.vjs-has-started.vjs-paused.vjs-show-big-play-button-on-pause .vjs-big-play-button {
  display: block;
}

.video-js button {
  background: none;
  border: none;
  color: inherit;
  display: inline-block;
  font-size: inherit;
  line-height: inherit;
  text-transform: none;
  text-decoration: none;
  transition: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.vjs-control .vjs-button {
  width: 100%;
  height: 100%;
}

.video-js .vjs-control.vjs-close-button {
  cursor: pointer;
  height: 3em;
  position: absolute;
  right: 0;
  top: 0.5em;
  z-index: 2;
}
.video-js .vjs-modal-dialog {
  background: rgba(0, 0, 0, 0.8);
  background: -webkit-linear-gradient(-90deg, rgba(0, 0, 0, 0.8), rgba(255, 255, 255, 0));
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.8), rgba(255, 255, 255, 0));
  overflow: auto;
}

.video-js .vjs-modal-dialog > * {
  box-sizing: border-box;
}

.vjs-modal-dialog .vjs-modal-dialog-content {
  font-size: 1.2em;
  line-height: 1.5;
  padding: 20px 24px;
  z-index: 1;
}

.vjs-menu-button {
  cursor: pointer;
}

.vjs-menu-button.vjs-disabled {
  cursor: default;
}

.vjs-workinghover .vjs-menu-button.vjs-disabled:hover .vjs-menu {
  display: none;
}

.vjs-menu .vjs-menu-content {
  display: block;
  padding: 0;
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
  overflow: auto;
}

.vjs-menu .vjs-menu-content > * {
  box-sizing: border-box;
}

.vjs-scrubbing .vjs-control.vjs-menu-button:hover .vjs-menu {
  display: none;
}

.vjs-menu li {
  list-style: none;
  margin: 0;
  padding: 0.2em 0;
  line-height: 1.4em;
  font-size: 1.2em;
  text-align: center;
  text-transform: lowercase;
}

.vjs-menu li.vjs-menu-item:focus,
.vjs-menu li.vjs-menu-item:hover,
.js-focus-visible .vjs-menu li.vjs-menu-item:hover {
  background-color: #73859f;
  background-color: rgba(115, 133, 159, 0.5);
}

.vjs-menu li.vjs-selected,
.vjs-menu li.vjs-selected:focus,
.vjs-menu li.vjs-selected:hover,
.js-focus-visible .vjs-menu li.vjs-selected:hover {
  background-color: #fff;
  color: #2B333F;
}

.video-js .vjs-menu *:focus:not(:focus-visible),
.js-focus-visible .vjs-menu *:focus:not(.focus-visible) {
  background: none;
}

.vjs-menu li.vjs-menu-title {
  text-align: center;
  text-transform: uppercase;
  font-size: 1em;
  line-height: 2em;
  padding: 0;
  margin: 0 0 0.3em 0;
  font-weight: bold;
  cursor: default;
}

.vjs-menu-button-popup .vjs-menu {
  display: none;
  position: absolute;
  bottom: 0;
  width: 10em;
  left: -3em;
  height: 0em;
  margin-bottom: 1.5em;
  border-top-color: rgba(43, 51, 63, 0.7);
}

.vjs-menu-button-popup .vjs-menu .vjs-menu-content {
  background-color: #2B333F;
  background-color: rgba(43, 51, 63, 0.7);
  position: absolute;
  width: 100%;
  bottom: 1.5em;
  max-height: 15em;
}

.vjs-layout-tiny .vjs-menu-button-popup .vjs-menu .vjs-menu-content,
.vjs-layout-x-small .vjs-menu-button-popup .vjs-menu .vjs-menu-content {
  max-height: 5em;
}

.vjs-layout-small .vjs-menu-button-popup .vjs-menu .vjs-menu-content {
  max-height: 10em;
}

.vjs-layout-medium .vjs-menu-button-popup .vjs-menu .vjs-menu-content {
  max-height: 14em;
}

.vjs-layout-large .vjs-menu-button-popup .vjs-menu .vjs-menu-content,
.vjs-layout-x-large .vjs-menu-button-popup .vjs-menu .vjs-menu-content,
.vjs-layout-huge .vjs-menu-button-popup .vjs-menu .vjs-menu-content {
  max-height: 25em;
}

.vjs-workinghover .vjs-menu-button-popup.vjs-hover .vjs-menu,
.vjs-menu-button-popup .vjs-menu.vjs-lock-showing {
  display: block;
}

.video-js .vjs-menu-button-inline {
  -webkit-transition: all 0.4s;
  -moz-transition: all 0.4s;
  -ms-transition: all 0.4s;
  -o-transition: all 0.4s;
  transition: all 0.4s;
  overflow: hidden;
}

.video-js .vjs-menu-button-inline:before {
  width: 2.222222222em;
}

.video-js .vjs-menu-button-inline:hover,
.video-js .vjs-menu-button-inline:focus,
.video-js .vjs-menu-button-inline.vjs-slider-active,
.video-js.vjs-no-flex .vjs-menu-button-inline {
  width: 12em;
}

.vjs-menu-button-inline .vjs-menu {
  opacity: 0;
  height: 100%;
  width: auto;
  position: absolute;
  left: 4em;
  top: 0;
  padding: 0;
  margin: 0;
  -webkit-transition: all 0.4s;
  -moz-transition: all 0.4s;
  -ms-transition: all 0.4s;
  -o-transition: all 0.4s;
  transition: all 0.4s;
}

.vjs-menu-button-inline:hover .vjs-menu,
.vjs-menu-button-inline:focus .vjs-menu,
.vjs-menu-button-inline.vjs-slider-active .vjs-menu {
  display: block;
  opacity: 1;
}

.vjs-no-flex .vjs-menu-button-inline .vjs-menu {
  display: block;
  opacity: 1;
  position: relative;
  width: auto;
}

.vjs-no-flex .vjs-menu-button-inline:hover .vjs-menu,
.vjs-no-flex .vjs-menu-button-inline:focus .vjs-menu,
.vjs-no-flex .vjs-menu-button-inline.vjs-slider-active .vjs-menu {
  width: auto;
}

.vjs-menu-button-inline .vjs-menu-content {
  width: auto;
  height: 100%;
  margin: 0;
  overflow: hidden;
}

.video-js .vjs-control-bar {
  display: none;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3em;
  background-color: #2B333F;
  background-color: rgba(43, 51, 63, 0.7);
}

.vjs-has-started .vjs-control-bar {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  visibility: visible;
  opacity: 1;
  -webkit-transition: visibility 0.1s, opacity 0.1s;
  -moz-transition: visibility 0.1s, opacity 0.1s;
  -ms-transition: visibility 0.1s, opacity 0.1s;
  -o-transition: visibility 0.1s, opacity 0.1s;
  transition: visibility 0.1s, opacity 0.1s;
}

.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {
  visibility: visible;
  opacity: 0;
  -webkit-transition: visibility 1s, opacity 1s;
  -moz-transition: visibility 1s, opacity 1s;
  -ms-transition: visibility 1s, opacity 1s;
  -o-transition: visibility 1s, opacity 1s;
  transition: visibility 1s, opacity 1s;
}

.vjs-controls-disabled .vjs-control-bar,
.vjs-using-native-controls .vjs-control-bar,
.vjs-error .vjs-control-bar {
  display: none !important;
}

.vjs-audio.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {
  opacity: 1;
  visibility: visible;
}

.vjs-has-started.vjs-no-flex .vjs-control-bar {
  display: table;
}

.video-js .vjs-control {
  position: relative;
  text-align: center;
  margin: 0;
  padding: 0;
  height: 100%;
  width: 4em;
  -webkit-box-flex: none;
  -moz-box-flex: none;
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
}

.vjs-button > .vjs-icon-placeholder:before {
  font-size: 1.8em;
  line-height: 1.67;
}

.vjs-button > .vjs-icon-placeholder {
  display: block;
}

.video-js .vjs-control:focus:before,
.video-js .vjs-control:hover:before,
.video-js .vjs-control:focus {
  text-shadow: 0em 0em 1em white;
}

.video-js .vjs-control-text {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.vjs-no-flex .vjs-control {
  display: table-cell;
  vertical-align: middle;
}

.video-js .vjs-custom-control-spacer {
  display: none;
}

.video-js .vjs-progress-control, .video-js .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker, .cld-video-player .vjs-control-bar .video-js .vjs-progress-control-events-blocker {
  cursor: pointer;
  -webkit-box-flex: auto;
  -moz-box-flex: auto;
  -webkit-flex: auto;
  -ms-flex: auto;
  flex: auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  min-width: 4em;
  touch-action: none;
}

.video-js .vjs-progress-control.disabled, .video-js .cld-video-player .vjs-control-bar .disabled.vjs-progress-control-events-blocker, .cld-video-player .vjs-control-bar .video-js .disabled.vjs-progress-control-events-blocker {
  cursor: default;
}

.vjs-live .vjs-progress-control, .vjs-live .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker, .cld-video-player .vjs-control-bar .vjs-live .vjs-progress-control-events-blocker {
  display: none;
}

.vjs-liveui .vjs-progress-control, .vjs-liveui .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker, .cld-video-player .vjs-control-bar .vjs-liveui .vjs-progress-control-events-blocker {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.vjs-no-flex .vjs-progress-control, .vjs-no-flex .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker, .cld-video-player .vjs-control-bar .vjs-no-flex .vjs-progress-control-events-blocker {
  width: auto;
}

.video-js .vjs-progress-holder {
  -webkit-box-flex: auto;
  -moz-box-flex: auto;
  -webkit-flex: auto;
  -ms-flex: auto;
  flex: auto;
  -webkit-transition: all 0.2s;
  -moz-transition: all 0.2s;
  -ms-transition: all 0.2s;
  -o-transition: all 0.2s;
  transition: all 0.2s;
  height: 0.3em;
}

.video-js .vjs-progress-control .vjs-progress-holder, .video-js .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker .vjs-progress-holder, .cld-video-player .vjs-control-bar .video-js .vjs-progress-control-events-blocker .vjs-progress-holder {
  margin: 0 10px;
}

.video-js .vjs-progress-control:hover .vjs-progress-holder, .video-js .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker:hover .vjs-progress-holder, .cld-video-player .vjs-control-bar .video-js .vjs-progress-control-events-blocker:hover .vjs-progress-holder {
  font-size: 1.6666666667em;
}

.video-js .vjs-progress-control:hover .vjs-progress-holder.disabled, .video-js .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker:hover .vjs-progress-holder.disabled, .cld-video-player .vjs-control-bar .video-js .vjs-progress-control-events-blocker:hover .vjs-progress-holder.disabled {
  font-size: 1em;
}

.video-js .vjs-progress-holder .vjs-play-progress,
.video-js .vjs-progress-holder .vjs-load-progress,
.video-js .vjs-progress-holder .vjs-load-progress div {
  position: absolute;
  display: block;
  height: 100%;
  margin: 0;
  padding: 0;
  width: 0;
}

.video-js .vjs-play-progress {
  background-color: #fff;
}
.video-js .vjs-play-progress:before {
  font-size: 0.9em;
  position: absolute;
  right: -0.5em;
  top: -0.3333333333em;
  z-index: 1;
}

.video-js .vjs-load-progress {
  background: rgba(115, 133, 159, 0.5);
}

.video-js .vjs-load-progress div {
  background: rgba(115, 133, 159, 0.75);
}

.video-js .vjs-time-tooltip {
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.8);
  -webkit-border-radius: 0.3em;
  -moz-border-radius: 0.3em;
  border-radius: 0.3em;
  color: #000;
  float: right;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1em;
  padding: 6px 8px 8px 8px;
  pointer-events: none;
  position: absolute;
  top: -3.4em;
  visibility: hidden;
  z-index: 1;
}

.video-js .vjs-progress-holder:focus .vjs-time-tooltip {
  display: none;
}

.video-js .vjs-progress-control:hover .vjs-time-tooltip, .video-js .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker:hover .vjs-time-tooltip, .cld-video-player .vjs-control-bar .video-js .vjs-progress-control-events-blocker:hover .vjs-time-tooltip,
.video-js .vjs-progress-control:hover .vjs-progress-holder:focus .vjs-time-tooltip {
  display: block;
  font-size: 0.6em;
  visibility: visible;
}

.video-js .vjs-progress-control.disabled:hover .vjs-time-tooltip, .video-js .cld-video-player .vjs-control-bar .disabled.vjs-progress-control-events-blocker:hover .vjs-time-tooltip, .cld-video-player .vjs-control-bar .video-js .disabled.vjs-progress-control-events-blocker:hover .vjs-time-tooltip {
  font-size: 1em;
}

.video-js .vjs-progress-control .vjs-mouse-display, .video-js .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker .vjs-mouse-display, .cld-video-player .vjs-control-bar .video-js .vjs-progress-control-events-blocker .vjs-mouse-display {
  display: none;
  position: absolute;
  width: 1px;
  height: 100%;
  background-color: #000;
  z-index: 1;
}

.vjs-no-flex .vjs-progress-control .vjs-mouse-display, .vjs-no-flex .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker .vjs-mouse-display, .cld-video-player .vjs-control-bar .vjs-no-flex .vjs-progress-control-events-blocker .vjs-mouse-display {
  z-index: 0;
}

.video-js .vjs-progress-control:hover .vjs-mouse-display, .video-js .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker:hover .vjs-mouse-display, .cld-video-player .vjs-control-bar .video-js .vjs-progress-control-events-blocker:hover .vjs-mouse-display {
  display: block;
}

.video-js.vjs-user-inactive .vjs-progress-control .vjs-mouse-display, .video-js.vjs-user-inactive .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker .vjs-mouse-display, .cld-video-player .vjs-control-bar .video-js.vjs-user-inactive .vjs-progress-control-events-blocker .vjs-mouse-display {
  visibility: hidden;
  opacity: 0;
  -webkit-transition: visibility 1s, opacity 1s;
  -moz-transition: visibility 1s, opacity 1s;
  -ms-transition: visibility 1s, opacity 1s;
  -o-transition: visibility 1s, opacity 1s;
  transition: visibility 1s, opacity 1s;
}

.video-js.vjs-user-inactive.vjs-no-flex .vjs-progress-control .vjs-mouse-display, .video-js.vjs-user-inactive.vjs-no-flex .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker .vjs-mouse-display, .cld-video-player .vjs-control-bar .video-js.vjs-user-inactive.vjs-no-flex .vjs-progress-control-events-blocker .vjs-mouse-display {
  display: none;
}

.vjs-mouse-display .vjs-time-tooltip {
  color: #fff;
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.8);
}

.video-js .vjs-slider {
  position: relative;
  cursor: pointer;
  padding: 0;
  margin: 0 0.45em 0 0.45em;
  /* iOS Safari */
  -webkit-touch-callout: none;
  /* Safari */
  -webkit-user-select: none;
  /* Konqueror HTML */
  -khtml-user-select: none;
  /* Firefox */
  -moz-user-select: none;
  /* Internet Explorer/Edge */
  -ms-user-select: none;
  /* Non-prefixed version, currently supported by Chrome and Opera */
  user-select: none;
  background-color: #73859f;
  background-color: rgba(115, 133, 159, 0.5);
}

.video-js .vjs-slider.disabled {
  cursor: default;
}

.video-js .vjs-slider:focus {
  text-shadow: 0em 0em 1em white;
  -webkit-box-shadow: 0 0 1em #fff;
  -moz-box-shadow: 0 0 1em #fff;
  box-shadow: 0 0 1em #fff;
}

.video-js .vjs-mute-control {
  cursor: pointer;
  -webkit-box-flex: none;
  -moz-box-flex: none;
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
}
.video-js .vjs-volume-control {
  cursor: pointer;
  margin-right: 1em;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.video-js .vjs-volume-control.vjs-volume-horizontal {
  width: 5em;
}

.video-js .vjs-volume-panel .vjs-volume-control {
  visibility: visible;
  opacity: 0;
  width: 1px;
  height: 1px;
  margin-left: -1px;
}

.video-js .vjs-volume-panel {
  -webkit-transition: width 1s;
  -moz-transition: width 1s;
  -ms-transition: width 1s;
  -o-transition: width 1s;
  transition: width 1s;
}
.video-js .vjs-volume-panel.vjs-hover .vjs-volume-control, .video-js .vjs-volume-panel:active .vjs-volume-control, .video-js .vjs-volume-panel:focus .vjs-volume-control, .video-js .vjs-volume-panel .vjs-volume-control:active, .video-js .vjs-volume-panel.vjs-hover .vjs-mute-control ~ .vjs-volume-control, .video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active {
  visibility: visible;
  opacity: 1;
  position: relative;
  -webkit-transition: visibility 0.1s, opacity 0.1s, height 0.1s, width 0.1s, left 0s, top 0s;
  -moz-transition: visibility 0.1s, opacity 0.1s, height 0.1s, width 0.1s, left 0s, top 0s;
  -ms-transition: visibility 0.1s, opacity 0.1s, height 0.1s, width 0.1s, left 0s, top 0s;
  -o-transition: visibility 0.1s, opacity 0.1s, height 0.1s, width 0.1s, left 0s, top 0s;
  transition: visibility 0.1s, opacity 0.1s, height 0.1s, width 0.1s, left 0s, top 0s;
}
.video-js .vjs-volume-panel.vjs-hover .vjs-volume-control.vjs-volume-horizontal, .video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-horizontal, .video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-horizontal, .video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-horizontal, .video-js .vjs-volume-panel.vjs-hover .vjs-mute-control ~ .vjs-volume-control.vjs-volume-horizontal, .video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-horizontal {
  width: 5em;
  height: 3em;
  margin-right: 0;
}
.video-js .vjs-volume-panel.vjs-hover .vjs-volume-control.vjs-volume-vertical, .video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-vertical, .video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-vertical, .video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-vertical, .video-js .vjs-volume-panel.vjs-hover .vjs-mute-control ~ .vjs-volume-control.vjs-volume-vertical, .video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-vertical {
  left: -3.5em;
  -webkit-transition: left 0s;
  -moz-transition: left 0s;
  -ms-transition: left 0s;
  -o-transition: left 0s;
  transition: left 0s;
}
.video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-hover, .video-js .vjs-volume-panel.vjs-volume-panel-horizontal:active, .video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active {
  width: 10em;
  -webkit-transition: width 0.1s;
  -moz-transition: width 0.1s;
  -ms-transition: width 0.1s;
  -o-transition: width 0.1s;
  transition: width 0.1s;
}
.video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-mute-toggle-only {
  width: 4em;
}

.video-js .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical {
  height: 8em;
  width: 3em;
  left: -3000em;
  -webkit-transition: visibility 1s, opacity 1s, height 1s 1s, width 1s 1s, left 1s 1s, top 1s 1s;
  -moz-transition: visibility 1s, opacity 1s, height 1s 1s, width 1s 1s, left 1s 1s, top 1s 1s;
  -ms-transition: visibility 1s, opacity 1s, height 1s 1s, width 1s 1s, left 1s 1s, top 1s 1s;
  -o-transition: visibility 1s, opacity 1s, height 1s 1s, width 1s 1s, left 1s 1s, top 1s 1s;
  transition: visibility 1s, opacity 1s, height 1s 1s, width 1s 1s, left 1s 1s, top 1s 1s;
}

.video-js .vjs-volume-panel .vjs-volume-control.vjs-volume-horizontal {
  -webkit-transition: visibility 1s, opacity 1s, height 1s 1s, width 1s, left 1s 1s, top 1s 1s;
  -moz-transition: visibility 1s, opacity 1s, height 1s 1s, width 1s, left 1s 1s, top 1s 1s;
  -ms-transition: visibility 1s, opacity 1s, height 1s 1s, width 1s, left 1s 1s, top 1s 1s;
  -o-transition: visibility 1s, opacity 1s, height 1s 1s, width 1s, left 1s 1s, top 1s 1s;
  transition: visibility 1s, opacity 1s, height 1s 1s, width 1s, left 1s 1s, top 1s 1s;
}

.video-js.vjs-no-flex .vjs-volume-panel .vjs-volume-control.vjs-volume-horizontal {
  width: 5em;
  height: 3em;
  visibility: visible;
  opacity: 1;
  position: relative;
  -webkit-transition: none;
  -moz-transition: none;
  -ms-transition: none;
  -o-transition: none;
  transition: none;
}

.video-js.vjs-no-flex .vjs-volume-control.vjs-volume-vertical,
.video-js.vjs-no-flex .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical {
  position: absolute;
  bottom: 3em;
  left: 0.5em;
}

.video-js .vjs-volume-panel {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.video-js .vjs-volume-bar {
  margin: 1.35em 0.45em;
}

.vjs-volume-bar.vjs-slider-horizontal {
  width: 5em;
  height: 0.3em;
}

.vjs-volume-bar.vjs-slider-vertical {
  width: 0.3em;
  height: 5em;
  margin: 1.35em auto;
}

.video-js .vjs-volume-level {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #fff;
}
.video-js .vjs-volume-level:before {
  position: absolute;
  font-size: 0.9em;
}

.vjs-slider-vertical .vjs-volume-level {
  width: 0.3em;
}
.vjs-slider-vertical .vjs-volume-level:before {
  top: -0.5em;
  left: -0.3em;
}

.vjs-slider-horizontal .vjs-volume-level {
  height: 0.3em;
}
.vjs-slider-horizontal .vjs-volume-level:before {
  top: -0.3em;
  right: -0.5em;
}

.video-js .vjs-volume-panel.vjs-volume-panel-vertical {
  width: 4em;
}

.vjs-volume-bar.vjs-slider-vertical .vjs-volume-level {
  height: 100%;
}

.vjs-volume-bar.vjs-slider-horizontal .vjs-volume-level {
  width: 100%;
}

.video-js .vjs-volume-vertical {
  width: 3em;
  height: 8em;
  bottom: 8em;
  background-color: #2B333F;
  background-color: rgba(43, 51, 63, 0.7);
}

.video-js .vjs-volume-horizontal .vjs-menu {
  left: -2em;
}

.vjs-poster {
  display: inline-block;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
  background-color: #000000;
  cursor: pointer;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
}

.vjs-has-started .vjs-poster {
  display: none;
}

.vjs-audio.vjs-has-started .vjs-poster {
  display: block;
}

.vjs-using-native-controls .vjs-poster {
  display: none;
}

.video-js .vjs-live-control {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: flex-start;
  -webkit-align-items: flex-start;
  -ms-flex-align: flex-start;
  align-items: flex-start;
  -webkit-box-flex: auto;
  -moz-box-flex: auto;
  -webkit-flex: auto;
  -ms-flex: auto;
  flex: auto;
  font-size: 1em;
  line-height: 3em;
}

.vjs-no-flex .vjs-live-control {
  display: table-cell;
  width: auto;
  text-align: left;
}

.video-js:not(.vjs-live) .vjs-live-control,
.video-js.vjs-liveui .vjs-live-control {
  display: none;
}

.video-js .vjs-seek-to-live-control {
  align-items: center;
  cursor: pointer;
  -webkit-box-flex: none;
  -moz-box-flex: none;
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
  display: inline-flex;
  height: 100%;
  padding-left: 0.5em;
  padding-right: 0.5em;
  font-size: 1em;
  line-height: 3em;
  width: auto;
  min-width: 4em;
}

.vjs-no-flex .vjs-seek-to-live-control {
  display: table-cell;
  width: auto;
  text-align: left;
}

.video-js.vjs-live:not(.vjs-liveui) .vjs-seek-to-live-control,
.video-js:not(.vjs-live) .vjs-seek-to-live-control {
  display: none;
}

.vjs-seek-to-live-control.vjs-control.vjs-at-live-edge {
  cursor: auto;
}

.vjs-seek-to-live-control .vjs-icon-placeholder {
  margin-right: 0.5em;
  color: #888;
}

.vjs-seek-to-live-control.vjs-control.vjs-at-live-edge .vjs-icon-placeholder {
  color: red;
}

.video-js .vjs-time-control {
  -webkit-box-flex: none;
  -moz-box-flex: none;
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
  font-size: 1em;
  line-height: 3em;
  min-width: 2em;
  width: auto;
  padding-left: 1em;
  padding-right: 1em;
}

.vjs-live .vjs-time-control {
  display: none;
}

.video-js .vjs-current-time,
.vjs-no-flex .vjs-current-time {
  display: none;
}

.video-js .vjs-duration,
.vjs-no-flex .vjs-duration {
  display: none;
}

.vjs-time-divider {
  display: none;
  line-height: 3em;
}

.vjs-live .vjs-time-divider {
  display: none;
}

.video-js .vjs-play-control {
  cursor: pointer;
}

.video-js .vjs-play-control .vjs-icon-placeholder {
  -webkit-box-flex: none;
  -moz-box-flex: none;
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
}

.vjs-text-track-display {
  position: absolute;
  bottom: 3em;
  left: 0;
  right: 0;
  top: 0;
  pointer-events: none;
}

.video-js.vjs-user-inactive.vjs-playing .vjs-text-track-display {
  bottom: 1em;
}

.video-js .vjs-text-track {
  font-size: 1.4em;
  text-align: center;
  margin-bottom: 0.1em;
}

.vjs-subtitles {
  color: #fff;
}

.vjs-captions {
  color: #fc6;
}

.vjs-tt-cue {
  display: block;
}

video::-webkit-media-text-track-display {
  -moz-transform: translateY(-3em);
  -ms-transform: translateY(-3em);
  -o-transform: translateY(-3em);
  -webkit-transform: translateY(-3em);
  transform: translateY(-3em);
}

.video-js.vjs-user-inactive.vjs-playing video::-webkit-media-text-track-display {
  -moz-transform: translateY(-1.5em);
  -ms-transform: translateY(-1.5em);
  -o-transform: translateY(-1.5em);
  -webkit-transform: translateY(-1.5em);
  transform: translateY(-1.5em);
}

.video-js .vjs-picture-in-picture-control {
  cursor: pointer;
  -webkit-box-flex: none;
  -moz-box-flex: none;
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
}
.video-js .vjs-fullscreen-control {
  cursor: pointer;
  -webkit-box-flex: none;
  -moz-box-flex: none;
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
}
.vjs-playback-rate > .vjs-menu-button,
.vjs-playback-rate .vjs-playback-rate-value {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.vjs-playback-rate .vjs-playback-rate-value {
  pointer-events: none;
  font-size: 1.5em;
  line-height: 2;
  text-align: center;
}

.vjs-playback-rate .vjs-menu {
  width: 4em;
  left: 0em;
}

.vjs-error .vjs-error-display .vjs-modal-dialog-content {
  font-size: 1.4em;
  text-align: center;
}

.vjs-error .vjs-error-display:before {
  color: #fff;
  content: "X";
  font-family: Arial, Helvetica, sans-serif;
  font-size: 4em;
  left: 0;
  line-height: 1;
  margin-top: -0.5em;
  position: absolute;
  text-shadow: 0.05em 0.05em 0.1em #000;
  text-align: center;
  top: 50%;
  vertical-align: middle;
  width: 100%;
}

.vjs-loading-spinner {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -25px 0 0 -25px;
  opacity: 0.85;
  text-align: left;
  border: 6px solid rgba(43, 51, 63, 0.7);
  box-sizing: border-box;
  background-clip: padding-box;
  width: 50px;
  height: 50px;
  border-radius: 25px;
  visibility: hidden;
}

.vjs-seeking .vjs-loading-spinner,
.vjs-waiting .vjs-loading-spinner {
  display: block;
  animation: vjs-spinner-show 0s linear 0.3s forwards;
}

.vjs-loading-spinner:before,
.vjs-loading-spinner:after {
  content: "";
  position: absolute;
  margin: -6px;
  box-sizing: inherit;
  width: inherit;
  height: inherit;
  border-radius: inherit;
  opacity: 1;
  border: inherit;
  border-color: transparent;
  border-top-color: white;
}

.vjs-seeking .vjs-loading-spinner:before,
.vjs-seeking .vjs-loading-spinner:after,
.vjs-waiting .vjs-loading-spinner:before,
.vjs-waiting .vjs-loading-spinner:after {
  -webkit-animation: vjs-spinner-spin 1.1s cubic-bezier(0.6, 0.2, 0, 0.8) infinite, vjs-spinner-fade 1.1s linear infinite;
  animation: vjs-spinner-spin 1.1s cubic-bezier(0.6, 0.2, 0, 0.8) infinite, vjs-spinner-fade 1.1s linear infinite;
}

.vjs-seeking .vjs-loading-spinner:before,
.vjs-waiting .vjs-loading-spinner:before {
  border-top-color: white;
}

.vjs-seeking .vjs-loading-spinner:after,
.vjs-waiting .vjs-loading-spinner:after {
  border-top-color: white;
  -webkit-animation-delay: 0.44s;
  animation-delay: 0.44s;
}

@keyframes vjs-spinner-show {
  to {
    visibility: visible;
  }
}
@-webkit-keyframes vjs-spinner-show {
  to {
    visibility: visible;
  }
}
@keyframes vjs-spinner-spin {
  100% {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes vjs-spinner-spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes vjs-spinner-fade {
  0% {
    border-top-color: #73859f;
  }
  20% {
    border-top-color: #73859f;
  }
  35% {
    border-top-color: white;
  }
  60% {
    border-top-color: #73859f;
  }
  100% {
    border-top-color: #73859f;
  }
}
@-webkit-keyframes vjs-spinner-fade {
  0% {
    border-top-color: #73859f;
  }
  20% {
    border-top-color: #73859f;
  }
  35% {
    border-top-color: white;
  }
  60% {
    border-top-color: #73859f;
  }
  100% {
    border-top-color: #73859f;
  }
}
.vjs-chapters-button .vjs-menu ul {
  width: 24em;
}

.video-js .vjs-subs-caps-button + .vjs-menu .vjs-captions-menu-item .vjs-menu-item-text .vjs-icon-placeholder {
  vertical-align: middle;
  display: inline-block;
  margin-bottom: -0.1em;
}

.video-js .vjs-subs-caps-button + .vjs-menu .vjs-captions-menu-item .vjs-menu-item-text .vjs-icon-placeholder:before {
  font-family: VideoJS;
  content: "";
  font-size: 1.5em;
  line-height: inherit;
}

.video-js .vjs-audio-button + .vjs-menu .vjs-main-desc-menu-item .vjs-menu-item-text .vjs-icon-placeholder {
  vertical-align: middle;
  display: inline-block;
  margin-bottom: -0.1em;
}

.video-js .vjs-audio-button + .vjs-menu .vjs-main-desc-menu-item .vjs-menu-item-text .vjs-icon-placeholder:before {
  font-family: VideoJS;
  content: " ";
  font-size: 1.5em;
  line-height: inherit;
}

.video-js:not(.vjs-fullscreen).vjs-layout-small .vjs-current-time,
.video-js:not(.vjs-fullscreen).vjs-layout-small .vjs-time-divider,
.video-js:not(.vjs-fullscreen).vjs-layout-small .vjs-duration,
.video-js:not(.vjs-fullscreen).vjs-layout-small .vjs-remaining-time,
.video-js:not(.vjs-fullscreen).vjs-layout-small .vjs-playback-rate,
.video-js:not(.vjs-fullscreen).vjs-layout-small .vjs-chapters-button,
.video-js:not(.vjs-fullscreen).vjs-layout-small .vjs-descriptions-button,
.video-js:not(.vjs-fullscreen).vjs-layout-small .vjs-captions-button,
.video-js:not(.vjs-fullscreen).vjs-layout-small .vjs-subtitles-button,
.video-js:not(.vjs-fullscreen).vjs-layout-small .vjs-audio-button,
.video-js:not(.vjs-fullscreen).vjs-layout-small .vjs-volume-control, .video-js:not(.vjs-fullscreen).vjs-layout-x-small .vjs-current-time,
.video-js:not(.vjs-fullscreen).vjs-layout-x-small .vjs-time-divider,
.video-js:not(.vjs-fullscreen).vjs-layout-x-small .vjs-duration,
.video-js:not(.vjs-fullscreen).vjs-layout-x-small .vjs-remaining-time,
.video-js:not(.vjs-fullscreen).vjs-layout-x-small .vjs-playback-rate,
.video-js:not(.vjs-fullscreen).vjs-layout-x-small .vjs-chapters-button,
.video-js:not(.vjs-fullscreen).vjs-layout-x-small .vjs-descriptions-button,
.video-js:not(.vjs-fullscreen).vjs-layout-x-small .vjs-captions-button,
.video-js:not(.vjs-fullscreen).vjs-layout-x-small .vjs-subtitles-button,
.video-js:not(.vjs-fullscreen).vjs-layout-x-small .vjs-audio-button,
.video-js:not(.vjs-fullscreen).vjs-layout-x-small .vjs-volume-control, .video-js:not(.vjs-fullscreen).vjs-layout-tiny .vjs-current-time,
.video-js:not(.vjs-fullscreen).vjs-layout-tiny .vjs-time-divider,
.video-js:not(.vjs-fullscreen).vjs-layout-tiny .vjs-duration,
.video-js:not(.vjs-fullscreen).vjs-layout-tiny .vjs-remaining-time,
.video-js:not(.vjs-fullscreen).vjs-layout-tiny .vjs-playback-rate,
.video-js:not(.vjs-fullscreen).vjs-layout-tiny .vjs-chapters-button,
.video-js:not(.vjs-fullscreen).vjs-layout-tiny .vjs-descriptions-button,
.video-js:not(.vjs-fullscreen).vjs-layout-tiny .vjs-captions-button,
.video-js:not(.vjs-fullscreen).vjs-layout-tiny .vjs-subtitles-button,
.video-js:not(.vjs-fullscreen).vjs-layout-tiny .vjs-audio-button,
.video-js:not(.vjs-fullscreen).vjs-layout-tiny .vjs-volume-control {
  display: none;
}
.video-js:not(.vjs-fullscreen).vjs-layout-small .vjs-volume-panel.vjs-volume-panel-horizontal:hover,
.video-js:not(.vjs-fullscreen).vjs-layout-small .vjs-volume-panel.vjs-volume-panel-horizontal:active,
.video-js:not(.vjs-fullscreen).vjs-layout-small .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active, .video-js:not(.vjs-fullscreen).vjs-layout-x-small .vjs-volume-panel.vjs-volume-panel-horizontal:hover,
.video-js:not(.vjs-fullscreen).vjs-layout-x-small .vjs-volume-panel.vjs-volume-panel-horizontal:active,
.video-js:not(.vjs-fullscreen).vjs-layout-x-small .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active, .video-js:not(.vjs-fullscreen).vjs-layout-tiny .vjs-volume-panel.vjs-volume-panel-horizontal:hover,
.video-js:not(.vjs-fullscreen).vjs-layout-tiny .vjs-volume-panel.vjs-volume-panel-horizontal:active,
.video-js:not(.vjs-fullscreen).vjs-layout-tiny .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active {
  width: auto;
  width: initial;
}
.video-js:not(.vjs-fullscreen).vjs-layout-x-small:not(.vjs-liveui) .vjs-subs-caps-button, .video-js:not(.vjs-fullscreen).vjs-layout-x-small:not(.vjs-live) .vjs-subs-caps-button, .video-js:not(.vjs-fullscreen).vjs-layout-tiny .vjs-subs-caps-button {
  display: none;
}
.video-js:not(.vjs-fullscreen).vjs-layout-x-small.vjs-liveui .vjs-custom-control-spacer, .video-js:not(.vjs-fullscreen).vjs-layout-tiny .vjs-custom-control-spacer {
  -webkit-box-flex: auto;
  -moz-box-flex: auto;
  -webkit-flex: auto;
  -ms-flex: auto;
  flex: auto;
  display: block;
}
.video-js:not(.vjs-fullscreen).vjs-layout-x-small.vjs-liveui.vjs-no-flex .vjs-custom-control-spacer, .video-js:not(.vjs-fullscreen).vjs-layout-tiny.vjs-no-flex .vjs-custom-control-spacer {
  width: auto;
}
.video-js:not(.vjs-fullscreen).vjs-layout-x-small.vjs-liveui .vjs-progress-control, .video-js:not(.vjs-fullscreen).vjs-layout-x-small.vjs-liveui .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker, .cld-video-player .vjs-control-bar .video-js:not(.vjs-fullscreen).vjs-layout-x-small.vjs-liveui .vjs-progress-control-events-blocker, .video-js:not(.vjs-fullscreen).vjs-layout-tiny .vjs-progress-control, .video-js:not(.vjs-fullscreen).vjs-layout-tiny .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker, .cld-video-player .vjs-control-bar .video-js:not(.vjs-fullscreen).vjs-layout-tiny .vjs-progress-control-events-blocker {
  display: none;
}

.vjs-modal-dialog.vjs-text-track-settings {
  background-color: #2B333F;
  background-color: rgba(43, 51, 63, 0.75);
  color: #fff;
  height: 70%;
}

.vjs-text-track-settings .vjs-modal-dialog-content {
  display: table;
}

.vjs-text-track-settings .vjs-track-settings-colors,
.vjs-text-track-settings .vjs-track-settings-font,
.vjs-text-track-settings .vjs-track-settings-controls {
  display: table-cell;
}

.vjs-text-track-settings .vjs-track-settings-controls {
  text-align: right;
  vertical-align: bottom;
}

@supports (display: grid) {
  .vjs-text-track-settings .vjs-modal-dialog-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    padding: 20px 24px 0px 24px;
  }

  .vjs-track-settings-controls .vjs-default-button {
    margin-bottom: 20px;
  }

  .vjs-text-track-settings .vjs-track-settings-controls {
    grid-column: 1/-1;
  }

  .vjs-layout-small .vjs-text-track-settings .vjs-modal-dialog-content,
.vjs-layout-x-small .vjs-text-track-settings .vjs-modal-dialog-content,
.vjs-layout-tiny .vjs-text-track-settings .vjs-modal-dialog-content {
    grid-template-columns: 1fr;
  }
}
.vjs-track-setting > select {
  margin-right: 1em;
  margin-bottom: 0.5em;
}

.vjs-text-track-settings fieldset {
  margin: 5px;
  padding: 3px;
  border: none;
}

.vjs-text-track-settings fieldset span {
  display: inline-block;
}

.vjs-text-track-settings fieldset span > select {
  max-width: 7.3em;
}

.vjs-text-track-settings legend {
  color: #fff;
  margin: 0 0 5px 0;
}

.vjs-text-track-settings .vjs-label {
  position: absolute;
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
  display: block;
  margin: 0 0 5px 0;
  padding: 0;
  border: 0;
  height: 1px;
  width: 1px;
  overflow: hidden;
}

.vjs-track-settings-controls button:focus,
.vjs-track-settings-controls button:active {
  outline-style: solid;
  outline-width: medium;
  background-image: linear-gradient(0deg, #fff 88%, #73859f 100%);
}

.vjs-track-settings-controls button:hover {
  color: rgba(43, 51, 63, 0.75);
}

.vjs-track-settings-controls button {
  background-color: #fff;
  background-image: linear-gradient(-180deg, #fff 88%, #73859f 100%);
  color: #2B333F;
  cursor: pointer;
  border-radius: 2px;
}

.vjs-track-settings-controls .vjs-default-button {
  margin-right: 1em;
}

@media print {
  .video-js > *:not(.vjs-tech):not(.vjs-poster) {
    visibility: hidden;
  }
}
.vjs-resize-manager {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  z-index: -1000;
}

.js-focus-visible .video-js *:focus:not(.focus-visible) {
  outline: none;
}

.video-js *:focus:not(:focus-visible) {
  outline: none;
}

.cld-video-player .vjs-time-tooltip,
.cld-video-player .vjs-mouse-display:after,
.cld-video-player .vjs-play-progress:after {
  font-weight: 300;
  padding: 0.4em 0.6em;
  top: -2.6em;
}
.cld-video-player .vjs-recommendations-overlay .vjs-recommendations-overlay-item:active:after,
.cld-video-player .vjs-recommendations-overlay .vjs-recommendations-overlay-item:hover:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  background-color: rgba(255, 255, 255, 0.2);
}
.cld-video-player .vjs-context-menu-ui .vjs-menu-content .vjs-menu-item {
  text-align: left;
}
.cld-video-player.vjs-ad-playing .vjs-play-control.vjs-paused, .cld-video-player.vjs-ad-playing .vjs-volume-level {
  background-color: transparent !important;
}
.cld-video-player.vjs-ad-playing .vjs-play-progress:before {
  display: none;
}

.cld-video-player.cld-video-player-skin-light .video-js button:hover,
.cld-video-player.cld-video-player-skin-light .vjs-volume-menu-button:hover {
  opacity: 0.9;
}
.cld-video-player.cld-video-player-skin-light .vjs-title-bar .vjs-title-bar-title:not(:empty) + .vjs-title-bar-subtitle:not(:empty):before {
  content: "•";
  padding: 0 0.45em;
  font-size: 1.4em;
  font-weight: 500;
}
.cld-video-player.cld-video-player-skin-light .vjs-title-bar {
  flex-direction: row;
  justify-content: left;
  height: 3.6em;
}
.cld-video-player.cld-video-player-skin-light .vjs-title-bar > div {
  width: auto;
  padding: 0;
  margin: 0;
}

@font-face {
  font-family: VideoJS;
  src: url(data:application/font-woff;charset=utf-8;base64,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) format("woff");
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-play, .video-js .vjs-big-play-button .vjs-icon-placeholder:before, .video-js .vjs-play-control .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-play:before, .video-js .vjs-big-play-button .vjs-icon-placeholder:before, .video-js .vjs-play-control .vjs-icon-placeholder:before {
  content: "";
}

.vjs-icon-play-circle {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-play-circle:before {
  content: "";
}

.vjs-icon-pause, .video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-pause:before, .video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder:before {
  content: "";
}

.vjs-icon-volume-mute, .video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-volume-mute:before, .video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder:before {
  content: "";
}

.vjs-icon-volume-low, .video-js .vjs-mute-control.vjs-vol-1 .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-volume-low:before, .video-js .vjs-mute-control.vjs-vol-1 .vjs-icon-placeholder:before {
  content: "";
}

.vjs-icon-volume-mid, .video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-volume-mid:before, .video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder:before {
  content: "";
}

.vjs-icon-volume-high, .video-js .vjs-mute-control .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-volume-high:before, .video-js .vjs-mute-control .vjs-icon-placeholder:before {
  content: "";
}

.vjs-icon-fullscreen-enter, .video-js .vjs-fullscreen-control .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-fullscreen-enter:before, .video-js .vjs-fullscreen-control .vjs-icon-placeholder:before {
  content: "";
}

.vjs-icon-fullscreen-exit, .video-js.vjs-fullscreen .vjs-fullscreen-control .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-fullscreen-exit:before, .video-js.vjs-fullscreen .vjs-fullscreen-control .vjs-icon-placeholder:before {
  content: "";
}

.vjs-icon-square {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-square:before {
  content: "";
}

.vjs-icon-spinner {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-spinner:before {
  content: "";
}

.vjs-icon-subtitles, .video-js .vjs-subtitles-button .vjs-icon-placeholder, .video-js .vjs-subs-caps-button .vjs-icon-placeholder,
.video-js.video-js:lang(en-GB) .vjs-subs-caps-button .vjs-icon-placeholder,
.video-js.video-js:lang(en-IE) .vjs-subs-caps-button .vjs-icon-placeholder,
.video-js.video-js:lang(en-AU) .vjs-subs-caps-button .vjs-icon-placeholder,
.video-js.video-js:lang(en-NZ) .vjs-subs-caps-button .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-subtitles:before, .video-js .vjs-subtitles-button .vjs-icon-placeholder:before, .video-js .vjs-subs-caps-button .vjs-icon-placeholder:before,
.video-js.video-js:lang(en-GB) .vjs-subs-caps-button .vjs-icon-placeholder:before,
.video-js.video-js:lang(en-IE) .vjs-subs-caps-button .vjs-icon-placeholder:before,
.video-js.video-js:lang(en-AU) .vjs-subs-caps-button .vjs-icon-placeholder:before,
.video-js.video-js:lang(en-NZ) .vjs-subs-caps-button .vjs-icon-placeholder:before {
  content: "";
}

.vjs-icon-captions, .video-js .vjs-captions-button .vjs-icon-placeholder, .video-js:lang(en) .vjs-subs-caps-button .vjs-icon-placeholder,
.video-js:lang(fr-CA) .vjs-subs-caps-button .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-captions:before, .video-js .vjs-captions-button .vjs-icon-placeholder:before, .video-js:lang(en) .vjs-subs-caps-button .vjs-icon-placeholder:before,
.video-js:lang(fr-CA) .vjs-subs-caps-button .vjs-icon-placeholder:before {
  content: "";
}

.vjs-icon-chapters, .video-js .vjs-chapters-button .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-chapters:before, .video-js .vjs-chapters-button .vjs-icon-placeholder:before {
  content: "";
}

.vjs-icon-share {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-share:before {
  content: "";
}

.vjs-icon-cog {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-cog:before {
  content: "";
}

.vjs-icon-circle, .video-js .vjs-play-progress, .video-js .vjs-volume-level, .vjs-seek-to-live-control .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-circle:before, .video-js .vjs-play-progress:before, .video-js .vjs-volume-level:before, .vjs-seek-to-live-control .vjs-icon-placeholder:before {
  content: "";
}

.vjs-icon-circle-outline {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-circle-outline:before {
  content: "";
}

.vjs-icon-circle-inner-circle {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-circle-inner-circle:before {
  content: "";
}

.vjs-icon-hd {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-hd:before {
  content: "";
}

.vjs-icon-cancel, .video-js .vjs-control.vjs-close-button .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-cancel:before, .video-js .vjs-control.vjs-close-button .vjs-icon-placeholder:before {
  content: "";
}

.vjs-icon-replay, .video-js .vjs-play-control.vjs-ended .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-replay:before, .video-js .vjs-play-control.vjs-ended .vjs-icon-placeholder:before {
  content: "";
}

.vjs-icon-play-previous {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-play-previous:before {
  content: "";
}

.vjs-icon-play-next {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-play-next:before {
  content: "";
}

.vjs-icon-close {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-close:before {
  content: "";
}

.vjs-icon-skip-10-min {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-skip-10-min:before {
  content: "";
}

.vjs-icon-skip-10-plus {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-skip-10-plus:before {
  content: "";
}

.vjs-icon-facebook {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-facebook:before {
  content: "";
}

.vjs-icon-gplus {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-gplus:before {
  content: "";
}

.vjs-icon-linkedin {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-linkedin:before {
  content: "";
}

.vjs-icon-twitter {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-twitter:before {
  content: "";
}

.vjs-icon-tumblr {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-tumblr:before {
  content: "";
}

.vjs-icon-pinterest {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-pinterest:before {
  content: "";
}

.vjs-icon-audio-description, .video-js .vjs-descriptions-button .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-audio-description:before, .video-js .vjs-descriptions-button .vjs-icon-placeholder:before {
  content: "";
}

.vjs-icon-audio, .video-js .vjs-audio-button .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-audio:before, .video-js .vjs-audio-button .vjs-icon-placeholder:before {
  content: "";
}

.vjs-icon-cart {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-cart:before {
  content: "";
}

.vjs-label-hidden {
  display: none !important;
}

.cld-video-player .vjs-control-bar .vjs-control.vjs-ads-label {
  line-height: 3em;
  font-weight: normal;
  text-align: center;
  display: none;
  width: auto;
  padding: 0 1em;
}

.cld-video-player.vjs-ad-playing .vjs-control.vjs-ads-label {
  display: block;
}

.cld-video-player .ima-fullscreen-div, .cld-video-player .ima-mute-div, .cld-video-player .ima-play-pause-div, .cld-video-player .ima-slider-div {
  line-height: 1.7;
}
.cld-video-player.vjs-ad-loading > video,
.cld-video-player.vjs-ad-loading > .vjs-poster {
  opacity: 0;
}

.ima-ad-container {
  top: 0;
  left: 0;
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
}
.ima-ad-container video {
  left: 0;
}

/* Move overlay if user fast-clicks play button. */
.video-js.vjs-playing .bumpable-ima-ad-container {
  margin-top: -50px;
}

/* Move overlay when controls are active. */
.video-js.vjs-user-inactive.vjs-playing .bumpable-ima-ad-container {
  margin-top: 0px;
}

.video-js.vjs-paused .bumpable-ima-ad-container,
.video-js.vjs-playing:hover .bumpable-ima-ad-container,
.video-js.vjs-user-active.vjs-playing .bumpable-ima-ad-container {
  margin-top: -50px;
}

.vjs-ima-non-linear .vjs-big-play-button,
.vjs-ima-non-linear .vjs-menu.vjs-settings-menu,
.vjs-ima-non-linear .vjs-info-overlay,
.vjs-ima-non-linear .vjs-modal-overlay,
.vjs-ima-non-linear .vjs-control-bar {
  z-index: 1112;
}

.ima-controls-div {
  bottom: 0px;
  height: 37px;
  position: absolute;
  overflow: hidden;
  display: none;
  opacity: 1;
  background-color: rgba(7, 20, 30, 0.7);
  background: -moz-linear-gradient(bottom, rgba(7, 20, 30, 0.7) 0%, rgba(7, 20, 30, 0) 100%);
  /* FF3.6+ */
  background: -webkit-gradient(linear, left bottom, left top, color-stop(0%, rgba(7, 20, 30, 0.7)), color-stop(100%, rgba(7, 20, 30, 0)));
  /* Chrome,Safari4+ */
  background: -webkit-linear-gradient(bottom, rgba(7, 20, 30, 0.7) 0%, rgba(7, 20, 30, 0) 100%);
  /* Chrome10+,Safari5.1+ */
  background: -o-linear-gradient(bottom, rgba(7, 20, 30, 0.7) 0%, rgba(7, 20, 30, 0) 100%);
  /* Opera 11.10+ */
  background: -ms-linear-gradient(bottom, rgba(7, 20, 30, 0.7) 0%, rgba(7, 20, 30, 0) 100%);
  /* IE10+ */
  background: linear-gradient(to top, rgba(7, 20, 30, 0.7) 0%, rgba(7, 20, 30, 0) 100%);
  /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#0007141E", endColorstr="#07141E",GradientType=0 );
  /* IE6-9 */
}

.ima-countdown-div {
  height: 10px;
  color: #FFFFFF;
  text-shadow: 0 0 0.2em #000;
  cursor: default;
}

.ima-seek-bar-div {
  top: 12px;
  height: 3px;
  position: absolute;
  background: rgba(255, 255, 255, 0.4);
}

.ima-progress-div {
  width: 0px;
  height: 3px;
  background-color: #ECC546;
}

.ima-play-pause-div, .ima-mute-div, .ima-slider-div, .ima-fullscreen-div {
  width: 35px;
  height: 20px;
  top: 11px;
  left: 0px;
  position: absolute;
  color: #CCCCCC;
  font-size: 1.5em;
  line-height: 2;
  text-align: center;
  font-family: VideoJS;
  cursor: pointer;
}

.ima-mute-div {
  left: auto;
  right: 85px;
}

.ima-slider-div {
  left: auto;
  right: 35px;
  width: 50px;
  height: 10px;
  top: 20px;
  background-color: #555555;
}

.ima-slider-level-div {
  width: 100%;
  height: 10px;
  background-color: #ECC546;
}

.ima-fullscreen-div {
  left: auto;
  right: 0px;
}

.ima-playing:before {
  content: "";
}

.ima-paused:before {
  content: "";
}

.ima-playing:hover:before, .ima-paused:hover:before {
  text-shadow: 0 0 1em #fff;
}

.ima-non-muted:before {
  content: "";
}

.ima-muted:before {
  content: "";
}

.ima-non-muted:hover:before, .ima-muted:hover:before {
  text-shadow: 0 0 1em #fff;
}

.ima-non-fullscreen:before {
  content: "";
}

.ima-fullscreen:before {
  content: "";
}

.ima-non-fullscreen:hover:before, .ima-fullscreen:hover:before {
  text-shadow: 0 0 1em #fff;
}

.video-js.vjs-ad-playing .vjs-control-bar {
  z-index: 1112;
}

.video-js.vjs-ad-playing .vjs-control-bar .vjs-progress-control, .video-js.vjs-ad-playing .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker, .cld-video-player .video-js.vjs-ad-playing .vjs-control-bar .vjs-progress-control-events-blocker {
  pointer-events: none;
}

.video-js.vjs-ad-playing .vjs-control-bar > :not(.vjs-play-control):not(.vjs-volume-menu-button):not(.vjs-time-control):not(.vjs-progress-control):not(.vjs-spacer):not(.vjs-fullscreen-control):not(.vjs-gradient):not(.ima-countdown-div),
.video-js.vjs-ad-playing .vjs-control-bar .vjs-mouse-display-tooltip,
.video-js.vjs-ad-playing .vjs-control-bar .vjs-progress-control:before,
.video-js.vjs-ad-playing .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker:before,
.cld-video-player .video-js.vjs-ad-playing .vjs-control-bar .vjs-progress-control-events-blocker:before,
.video-js.vjs-ad-playing .vjs-control-bar .vjs-play-progress:before,
.video-js.vjs-ad-playing .vjs-control-bar .vjs-progress-control .vjs-load-progress,
.video-js.vjs-ad-playing .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker .vjs-load-progress,
.cld-video-player .video-js.vjs-ad-playing .vjs-control-bar .vjs-progress-control-events-blocker .vjs-load-progress,
.video-js.vjs-ad-playing .vjs-control-bar .vjs-progress-control .vjs-mouse-display,
.video-js.vjs-ad-playing .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker .vjs-mouse-display,
.cld-video-player .video-js.vjs-ad-playing .vjs-control-bar .vjs-progress-control-events-blocker .vjs-mouse-display {
  display: none;
}

.video-js.vjs-ad-playing .vjs-control-bar {
  transition: height 0.1s ease;
}

.video-js.vjs-ad-playing.vjs-user-inactive:not(.vjs-ad-paused) .vjs-control-bar {
  opacity: 1;
  height: 0;
}

.video-js.vjs-ad-playing.vjs-user-inactive:not(.vjs-ad-paused) .vjs-control-bar .vjs-progress-holder {
  margin: 0;
}

.video-js.vjs-ad-playing .vjs-control-bar > :not(.vjs-progress-control):not(.ima-countdown-div) {
  transition: opacity 0.1s ease, visibility 0.1s ease;
}

.video-js.vjs-ad-playing .vjs-control-bar > :not(.vjs-progress-control):not(.ima-countdown-div) div {
  transition: line-height 0.1s ease;
}

.video-js.vjs-ad-playing.vjs-user-inactive:not(.vjs-ad-paused) .vjs-control-bar > :not(.vjs-progress-control):not(.ima-countdown-div) {
  opacity: 0;
  visibility: hidden;
  overflow: hidden;
}

.video-js.vjs-ad-playing.vjs-user-inactive:not(.vjs-ad-paused) .vjs-control-bar > :not(.vjs-progress-control):not(.ima-countdown-div) div {
  line-height: 0.01em;
}

.video-js.vjs-ad-playing .vjs-control-bar .vjs-progress-control .vjs-thumbnail-holder, .video-js.vjs-ad-playing .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker .vjs-thumbnail-holder, .cld-video-player .video-js.vjs-ad-playing .vjs-control-bar .vjs-progress-control-events-blocker .vjs-thumbnail-holder,
.video-js.vjs-ad-playing .vjs-control-bar .vjs-progress-control .vjs-thumbnail,
.video-js.vjs-ad-playing .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker .vjs-thumbnail,
.cld-video-player .video-js.vjs-ad-playing .vjs-control-bar .vjs-progress-control-events-blocker .vjs-thumbnail {
  display: none !important;
}

.video-js.vjs-ad-playing .vjs-control-bar .vjs-progress-control .vjs-progress-holder, .video-js.vjs-ad-playing .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker .vjs-progress-holder, .cld-video-player .video-js.vjs-ad-playing .vjs-control-bar .vjs-progress-control-events-blocker .vjs-progress-holder {
  cursor: auto;
  box-shadow: none;
  font-size: 100%;
  margin: 0 1em;
}

.video-js .vjs-control-bar .ima-countdown-div {
  display: none;
  z-index: 1;
}

.video-js.vjs-ad-playing .vjs-control-bar .ima-countdown-div {
  display: block;
  position: absolute;
  margin-top: -2em;
  left: 2em;
  font-size: 1.2em;
}

.video-js .vjs-control:before {
  font-size: 2em;
  line-height: 1.5em;
}

.video-js .vjs-control {
  width: 3em;
}

.video-js .vjs-control,
.vjs-icon-close,
.vjs-volume-bar {
  z-index: 1;
}

.video-js .vjs-control:focus,
.vjs-big-play-button:focus,
.vjs-icon-close:focus,
.vjs-volume-bar:focus {
  outline: none;
}
.video-js .vjs-control:hover,
.vjs-big-play-button:hover,
.vjs-icon-close:hover,
.vjs-volume-bar:hover {
  opacity: 0.95;
}

.vjs-cloudinary-button:focus {
  opacity: 0.8;
}

.cld-video-player.cld-video-player-skin-dark .vjs-big-play-button:focus {
  background-color: rgba(40, 40, 40, 0.8);
}
.cld-video-player.cld-video-player-skin-light .vjs-big-play-button:focus {
  background-color: rgba(223, 234, 252, 0.8);
}

.cld-video-player-skin-light .vjs-control:focus {
  text-shadow: 0 0 1em #0E2F5A;
}

.cld-video-player {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: 300;
}
.cld-video-player.vjs-user-active .interaction-areas-container {
  opacity: 1;
}
.cld-video-player .interaction-areas-container {
  opacity: 0;
  transition: opacity 0.5s;
}
.cld-video-player .interaction-areas-container .go-back-button,
.cld-video-player .interaction-areas-container .video-player-interaction-area {
  position: absolute;
  cursor: pointer;
}
.cld-video-player .interaction-areas-container .go-back-button {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.cld-video-player .interaction-areas-container .video-player-interaction-area {
  border: solid 1px red;
}
.cld-video-player:focus {
  outline: none;
}
.cld-video-player.cld-fluid {
  width: 100%;
  max-width: 100%;
}
.cld-video-player.cld-fluid .vjs-poster {
  background: #000;
  background-size: cover;
}
.cld-video-player .vjs-time-control {
  padding-left: 0;
  padding-right: 0;
}
.cld-video-player .vjs-time-divider {
  min-width: 1em;
  display: block;
}
.cld-video-player .vjs-current-time {
  display: block;
}
.cld-video-player .vjs-remaining-time {
  display: none;
}
.cld-video-player .vjs-duration {
  display: block;
}
.cld-video-player .vjs-big-play-button {
  font-size: 5em;
  width: 1.5em;
  height: auto;
  border: 0;
  border-radius: 50%;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
}
.cld-video-player .vjs-big-play-button:before {
  content: "";
  position: relative;
  display: block;
  width: 100%;
  padding-bottom: 100%;
}
.cld-video-player .vjs-big-play-button .vjs-icon-placeholder {
  display: block;
  position: absolute;
  top: 30%;
  left: 40%;
  height: 40%;
  width: 30%;
  overflow: hidden;
}
.cld-video-player .vjs-big-play-button .vjs-icon-placeholder:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 100%;
  display: block;
  width: 0;
  height: 0;
  border-left: 300px solid currentColor;
  border-top: 200px solid transparent;
  border-bottom: 200px solid transparent;
  margin-left: -300px;
  margin-top: -200px;
}
.cld-video-player.cld-fluid .vjs-big-play-button {
  max-width: 15%;
}
.cld-video-player.vjs-big-play-button-init-only.vjs-has-started .vjs-big-play-button {
  display: none;
}
.cld-video-player.vjs-paused .vjs-big-play-button, .cld-video-player.vjs-paused.vjs-has-started .vjs-big-play-button {
  opacity: 1;
  visibility: visible;
}
.cld-video-player.vjs-error .vjs-error-display {
  background: #90A0B3;
}
.cld-video-player.vjs-error .vjs-error-display:before {
  display: none;
}
.cld-video-player.vjs-error .vjs-error-display .vjs-modal-dialog-content {
  font-size: 20px;
  font-weight: 500;
  text-align: left;
  padding: 0 10%;
  display: flex;
  align-items: center;
}
.cld-video-player.vjs-error .vjs-error-display .vjs-modal-dialog-content:before {
  content: "";
  width: 34px;
  height: 34px;
  margin-right: 10px;
  background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzRweCIgaGVpZ2h0PSIzNHB4IiB2aWV3Qm94PSIwIDAgMzQgMzQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA1NS4xICg3ODEzNikgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+RkFCNDUzODAtMkQ2Qy00Rjc0LUE0MTUtRTg0MkEwNDg4NDUxPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxnIGlkPSJWZXJzaW9uLTAtMiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlZDLTEtNS1FcnJvciIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU0MS4wMDAwMDAsIC0zMjQuMDAwMDAwKSIgZmlsbD0iI0ZGRkZGRiI+CiAgICAgICAgICAgIDxnIGlkPSJHcm91cC0zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgLTEuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iVmlkZW8tUGxheWVyL0RhcmsiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ3MC4wMDAwMDAsIDg1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxnIGlkPSJpY29uL2luZm8vb3V0bGluZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzAuMDAwMDAwLCAyMzkuMDQ0NDQ0KSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNi4zMTI1LDI2LjQzNzUgTDE5LjY4NzUsMjYuNDM3NSBMMTkuNjg3NSwxNi4zMTI1IEwxNi4zMTI1LDE2LjMxMjUgTDE2LjMxMjUsMjYuNDM3NSBaIE0xOCwxLjEyNSBDOC42ODUsMS4xMjUgMS4xMjUsOC42ODUgMS4xMjUsMTggQzEuMTI1LDI3LjMxNSA4LjY4NSwzNC44NzUgMTgsMzQuODc1IEMyNy4zMTUsMzQuODc1IDM0Ljg3NSwyNy4zMTUgMzQuODc1LDE4IEMzNC44NzUsOC42ODUgMjcuMzE1LDEuMTI1IDE4LDEuMTI1IFogTTE4LDMxLjUgQzEwLjU1ODEyNSwzMS41IDQuNSwyNS40NDE4NzUgNC41LDE4IEM0LjUsMTAuNTU4MTI1IDEwLjU1ODEyNSw0LjUgMTgsNC41IEMyNS40NDE4NzUsNC41IDMxLjUsMTAuNTU4MTI1IDMxLjUsMTggQzMxLjUsMjUuNDQxODc1IDI1LjQ0MTg3NSwzMS41IDE4LDMxLjUgWiBNMTYuMzEyNSwxMi45Mzc1IEwxOS42ODc1LDEyLjkzNzUgTDE5LjY4NzUsOS41NjI1IEwxNi4zMTI1LDkuNTYyNSBMMTYuMzEyNSwxMi45Mzc1IFoiIGlkPSJpY19pbmZvX291dGxpbmVfMjRweCI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==);
  transform: translateY(-1px);
  flex-shrink: 0;
}
.cld-video-player.vjs-controls-disabled .vjs-big-play-button, .cld-video-player.vjs-has-started .vjs-big-play-button, .cld-video-player.vjs-using-native-controls .vjs-big-play-button, .cld-video-player.vjs-error .vjs-big-play-button {
  transition: visibility 0.2s, opacity 0.2s;
  display: block;
  visibility: hidden;
  opacity: 0;
}
.cld-video-player .vjs-control-bar {
  z-index: 1;
}
.cld-video-player .vjs-control-bar .vjs-volume-panel {
  margin-right: 1em;
}
.cld-video-player .vjs-control-bar .vjs-menu-button-inline:hover,
.cld-video-player .vjs-control-bar .vjs-menu-button-inline:focus,
.cld-video-player .vjs-control-bar .vjs-menu-button-inline.vjs-slider-active,
.cld-video-player .vjs-control-bar .vjs-no-flex .vjs-menu-button-inline {
  width: 10em;
}
.cld-video-player .vjs-control-bar .vjs-menu-button-inline:before {
  width: 1.6em;
}
.cld-video-player .vjs-control-bar .vjs-menu-button-inline .vjs-menu {
  left: 3em;
}
.cld-video-player .vjs-control-bar .vjs-progress-control, .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker {
  position: absolute;
  left: 0px;
  width: 100%;
  background-color: inherit;
  height: 1em;
  padding: 0.7em 0.2em 0 0.2em;
  bottom: 3em;
}
.cld-video-player .vjs-control-bar .vjs-progress-holder {
  height: 0.25em;
}
.cld-video-player .vjs-control-bar .vjs-progress-control:hover .vjs-progress-holder, .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker:hover .vjs-progress-holder {
  font-size: 1.2em;
  transition: none;
}
.cld-video-player .vjs-control-bar .vjs-progress-control:hover .vjs-time-tooltip, .cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker:hover .vjs-time-tooltip {
  font-size: 0.8em;
}
.cld-video-player .vjs-control-bar .vjs-play-progress::before {
  top: -0.25em;
}
.cld-video-player .vjs-control-bar .vjs-progress-control-events-blocker {
  background-color: transparent;
}
.cld-video-player .vjs-subs-caps-button .vjs-texttrack-settings {
  display: none;
}
.cld-video-player .vjs-subs-caps-button .vjs-captions-menu-item .vjs-menu-item-text .vjs-icon-placeholder {
  vertical-align: top;
  display: inline-block;
  margin-bottom: -0.3em;
}
.cld-video-player .vjs-menu .vjs-menu-content {
  min-width: 10em;
  width: auto;
  overflow: visible;
  padding: 0.2em 0;
}
.cld-video-player .vjs-menu .vjs-menu-item {
  text-align: left;
  white-space: nowrap;
  text-transform: capitalize;
  font-size: 1em;
  padding: 0 1em;
  line-height: 2em;
}
.cld-video-player .vjs-menu .vjs-menu-item.vjs-selected {
  font-weight: bold;
}
.cld-video-player .vjs-spacer {
  flex: auto;
}
.cld-video-player .vjs-modal-dialog {
  background: none;
}
.vjs-control-bar a.vjs-control.vjs-cloudinary-button {
  background-image: url(fonts/cloudinary_icon_for_black_bg.svg);
  background-size: 25px;
  background-position: center;
  background-repeat: no-repeat;
}
.cld-video-player-skin-light .vjs-control-bar a.vjs-control.vjs-cloudinary-button {
  background-image: url(fonts/cloudinary_icon_for_white_bg.svg);
}
.vjs-control-bar a.vjs-control.vjs-cloudinary-button:hover {
  cursor: pointer;
}
.cld-plw-horizontal .cld-plw-col-list {
  padding-top: 14.0625%;
  position: relative;
}
.cld-plw-horizontal .cld-plw-panel {
  overflow: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  flex-direction: row;
}
.cld-plw-horizontal .cld-plw-panel-item {
  background-image: none;
  min-width: 25%;
  max-width: 25%;
}
.cld-plw-horizontal .cld-plw-panel-item:first-child {
  margin-left: 0;
}
.cld-plw-horizontal .cld-plw-panel-item:last-child {
  margin-right: 0;
}

.cld-plw-vertical {
  display: flex;
  flex-direction: row;
}
.cld-plw-vertical.cld-plw-layout > div:first-child {
  flex: 1;
}
.cld-plw-vertical .cld-plw-col-list {
  display: flex;
  flex-direction: column;
  min-width: 20%;
}
.cld-plw-vertical .cld-plw-panel {
  height: 100%;
  overflow: auto;
}
.cld-plw-vertical .cld-plw-panel-item {
  height: 25%;
}
.cld-plw-vertical .cld-plw-panel-item:last-child {
  margin-bottom: 0;
}

.cld-plw-item-title-next {
  font-weight: bold;
}

.cld-plw-item-info-wrap {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 5% 7%;
  width: 100%;
  transition: color 0.25s;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  box-sizing: border-box;
}
.cld-video-player-skin-dark .cld-plw-item-info-wrap {
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
}
@media only screen and (max-width: 768px) {
  .cld-video-player-skin-dark .cld-plw-item-info-wrap {
    background: #272727;
  }
}

.cld-plw-item-title {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cld-plw-item-duration {
  margin-left: 10px;
}

/*  Default Playlist Layout */
.cld-plw-layout.cld-plw-layout-fluid {
  width: 100%;
}
.cld-plw-layout.cld-plw-vertical {
  flex-direction: row;
}
.cld-plw-layout.cld-plw-horizontal {
  flex-direction: column;
}

.cld-plw-custom {
  padding: 4px;
}
.cld-plw-custom .cld-plw-panel-item {
  background: none !important;
  margin: 4px 0;
}
.cld-plw-custom .cld-plw-panel-item:first-child {
  margin-top: 0;
}
.cld-plw-custom .cld-plw-panel-item:last-child {
  margin-bottom: 0;
}
.cld-plw-custom .cld-plw-panel-item img {
  display: block;
  width: 150px;
}
.cld-plw-custom .cld-plw-panel-item .cld-plw-item-info-wrap {
  left: 160px;
}
.cld-plw-custom .cld-plw-panel-item .cld-plw-item-title-next {
  display: block;
}

@media only screen and (max-width: 768px) {
  .cld-plw-layout.cld-plw-vertical, .cld-plw-layout.cld-plw-horizontal {
    flex-direction: column;
  }
  .cld-plw-layout.cld-plw-vertical .cld-plw-panel, .cld-plw-layout.cld-plw-horizontal .cld-plw-panel {
    flex-direction: column;
  }
  .cld-plw-layout.cld-plw-vertical .cld-plw-col-list, .cld-plw-layout.cld-plw-horizontal .cld-plw-col-list {
    width: inherit !important;
    height: inherit !important;
    max-height: 340px;
  }
  .cld-plw-layout.cld-plw-vertical .cld-plw-panel-item, .cld-plw-layout.cld-plw-horizontal .cld-plw-panel-item {
    background: none !important;
  }
  .cld-plw-layout.cld-plw-vertical .cld-plw-panel-item img, .cld-plw-layout.cld-plw-horizontal .cld-plw-panel-item img {
    display: block;
    width: 150px;
    height: 84px;
  }
  .cld-plw-layout.cld-plw-vertical .cld-plw-panel-item .cld-plw-item-info-wrap, .cld-plw-layout.cld-plw-horizontal .cld-plw-panel-item .cld-plw-item-info-wrap {
    left: 150px;
    padding: 15px 10px;
    top: 0;
    right: 0;
    width: auto;
  }
  .cld-plw-layout.cld-plw-vertical .cld-plw-panel-item .cld-plw-item-title-next, .cld-plw-layout.cld-plw-horizontal .cld-plw-panel-item .cld-plw-item-title-next {
    display: block;
  }
  .cld-plw-layout.cld-plw-vertical .cld-plw-panel-item .cld-plw-item-title-curr, .cld-plw-layout.cld-plw-horizontal .cld-plw-panel-item .cld-plw-item-title-curr {
    display: block;
  }
  .cld-plw-layout.cld-plw-vertical .cld-plw-panel-item .cld-plw-item-title, .cld-plw-layout.cld-plw-horizontal .cld-plw-panel-item .cld-plw-item-title {
    white-space: normal;
  }
  .cld-plw-layout.cld-plw-horizontal .cld-plw-col-list {
    padding-top: 0;
    overflow: auto;
  }
  .cld-plw-layout.cld-plw-horizontal .cld-plw-panel {
    position: initial;
  }
  .cld-plw-layout.cld-plw-horizontal .cld-plw-panel-item {
    max-width: none;
  }
}
.cld-thumbnail {
  position: relative;
  display: block;
  width: 100%;
  overflow: hidden;
  font-size: 1em;
  text-align: left;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}
.cld-thumbnail .cld-thumbnail-img {
  display: none;
}
.cld-video-player-skin-light .cld-thumbnail .cld-plw-item-info-wrap {
  background: #fff;
}
.cld-video-player-skin-light .cld-thumbnail.cld-plw-panel-item-active {
  border: 1px solid #0078FF;
  box-sizing: border-box;
}
.cld-video-player-skin-light .cld-thumbnail.cld-plw-panel-item-active .cld-plw-item-info-wrap {
  background: rgba(0, 119, 255, 0.8);
}
.cld-video-player-skin-light .cld-thumbnail.cld-plw-panel-item-active .cld-plw-item-info-wrap {
  color: #fff;
}
.cld-video-player-skin-light .cld-thumbnail.cld-plw-panel-item-active:hover .cld-plw-item-info-wrap {
  color: #fff;
}
.cld-video-player-skin-dark .cld-thumbnail:before {
  content: "";
  position: absolute;
  top: 40%;
  max-height: 60%;
  right: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent 80%);
  opacity: 1;
}
.cld-video-player-skin-dark .cld-thumbnail.cld-plw-panel-item-active {
  border: 1px solid #FF620C;
  box-sizing: border-box;
}
@media only screen and (min-width: 769px) {
  .cld-video-player-skin-dark .cld-thumbnail.cld-plw-panel-item-active:before {
    background: linear-gradient(to top, rgba(0, 0, 0, 0.9), transparent 90%);
  }
  .cld-video-player-skin-dark .cld-thumbnail.cld-plw-panel-item-active .cld-plw-item-info-wrap {
    font-weight: 500;
  }
}
.cld-video-player-skin-dark .cld-thumbnail.cld-plw-panel-item-active .cld-plw-item-info-wrap {
  color: #FF620C;
}

.cld-plw-panel-item:hover:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  background-color: rgba(255, 255, 255, 0.2);
}

@media only screen and (max-width: 768px) {
  .cld-thumbnail:before {
    background: none;
  }
}
.vjs-recommendations-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: hidden;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.vjs-recommendations-overlay .vjs-recommendations-overlay-hide {
  font-size: 1em;
  cursor: pointer;
  position: absolute;
  display: inline-block;
  top: 3.75%;
  right: 1.72%;
}
.vjs-recommendations-overlay .vjs-recommendations-overlay-content {
  position: relative;
  width: 85%;
}
.vjs-recommendations-overlay .vjs-recommendations-overlay-content:before {
  display: block;
  content: "";
  width: 100%;
  padding-top: 56.25%;
}
.vjs-recommendations-overlay .vjs-recommendations-overlay-content > .aspect-ratio-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content {
  display: flex;
  flex-flow: column;
  height: auto;
}
.vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content .vjs-recommendations-overlay-item {
  border: 1px solid rgba(255, 255, 255, 0.5);
}
.vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content .vjs-recommendations-overlay-item-primary {
  flex: 1.82;
  display: flex;
  flex-flow: row;
}
.vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content .vjs-recommendations-overlay-item-primary .vjs-recommendations-overlay-item-primary-image {
  flex: 1;
  background-size: cover;
}
.vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content .vjs-recommendations-overlay-item-primary .vjs-recommendations-overlay-item-primary-content {
  flex: 0.5625;
  display: flex;
  flex-flow: column;
  background: rgba(0, 0, 0, 0.6);
  text-align: left;
  padding: 3%;
  min-width: 0;
}
.vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content .vjs-recommendations-overlay-item-primary .vjs-recommendations-overlay-item-primary-content h2 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 0 0 0;
  font-size: 18px;
  margin: 0 0 1em 0;
  font-weight: 600;
}
.vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content .vjs-recommendations-overlay-item-primary .vjs-recommendations-overlay-item-primary-content h3 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 0 0 0;
  font-size: 20px;
  margin: 0 0 1.3em 0;
  font-weight: 500;
}
.vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content .vjs-recommendations-overlay-item-primary .vjs-recommendations-overlay-item-primary-content p {
  padding: 0 0 0 0;
  margin: 0 0 0 0;
  font-size: 14px;
  overflow: hidden;
  line-height: 1.4em;
  font-weight: 400;
}
@media only screen and (max-width: 1050px) {
  .vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content .vjs-recommendations-overlay-item-primary .vjs-recommendations-overlay-item-primary-content h2 {
    font-size: 16px;
  }
  .vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content .vjs-recommendations-overlay-item-primary .vjs-recommendations-overlay-item-primary-content h3 {
    font-size: 18px;
  }
  .vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content .vjs-recommendations-overlay-item-primary .vjs-recommendations-overlay-item-primary-content p {
    font-size: 12px;
  }
}
@media only screen and (max-width: 900px) {
  .vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content .vjs-recommendations-overlay-item-primary .vjs-recommendations-overlay-item-primary-content p {
    font-size: 10px;
  }
}
@media only screen and (max-width: 768px) {
  .vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content .vjs-recommendations-overlay-item-primary .vjs-recommendations-overlay-item-primary-content p {
    display: none;
  }
}
.vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content .vjs-recommendations-overlay-item-secondary-container {
  flex: 1;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
}
.vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content .vjs-recommendations-overlay-item-secondary-container .vjs-recommendations-overlay-item-secondary {
  background-size: 100% 100%;
  flex: 1;
  max-width: 33%;
  font-size: 1.16em;
  position: relative;
  margin: 2% 2% 0 0;
}
.vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content .vjs-recommendations-overlay-item-secondary-container .vjs-recommendations-overlay-item-secondary:last-child {
  margin-right: 0;
}
.vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content .vjs-recommendations-overlay-item-secondary-container .vjs-recommendations-overlay-item-secondary div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-align: left;
  line-height: normal;
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  padding: 20% 7% 4.5% 7%;
}
.cld-video-player-skin-light .vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content .vjs-recommendations-overlay-item-secondary-container .vjs-recommendations-overlay-item-secondary div {
  padding: 5% 7%;
}
.cld-video-player-skin-dark .vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content .vjs-recommendations-overlay-item-secondary-container .vjs-recommendations-overlay-item-secondary div.vjs-recommendations-overlay-item-info {
  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.3);
}
.vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content .vjs-recommendations-overlay-item-secondary-container .vjs-recommendations-overlay-item-secondary div span {
  display: block;
  min-width: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content .vjs-recommendations-overlay-item-secondary-container .vjs-recommendations-overlay-item-secondary div span.vjs-recommendations-overlay-item-secondary-title {
  flex: 2.3;
  font-size: 13px;
}
.vjs-recommendations-overlay .vjs-recommendations-overlay-content .aspect-ratio-content .vjs-recommendations-overlay-item-secondary-container .vjs-recommendations-overlay-item-secondary div span.vjs-recommendations-overlay-item-secondary-duration {
  text-align: right;
  margin-left: 10px;
}
.video-js .vjs-title-bar {
  display: none;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  height: 7.2em;
  text-align: left;
  padding: 16px 21px;
  pointer-events: none;
}
.video-js .vjs-title-bar .vjs-title-bar-title {
  width: 100%;
  font-size: 1.2em;
  font-weight: 500;
  line-height: 1.2em;
  margin-bottom: 0.55em;
}
.video-js .vjs-title-bar .vjs-title-bar-subtitle {
  width: 100%;
  font-size: 1em;
  font-weight: 300;
  line-height: 1em;
}

.vjs-has-started .vjs-title-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  visibility: visible;
  opacity: 1;
  transition: visibility 0.1s, opacity 0.1s;
}

.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-title-bar {
  visibility: visible;
  opacity: 0;
  transition: visibility 1s, opacity 1s;
}

.vjs-controls-disabled .vjs-title-bar,
.vjs-using-native-controls .vjs-title-bar,
.vjs-error .vjs-title-bar,
.vjs-ad-playing .vjs-title-bar {
  display: none !important;
}

.vjs-audio.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-title-bar {
  opacity: 1;
  visibility: visible;
}

.vjs-has-started.vjs-no-flex .vjs-title-bar {
  display: table;
}
.video-js .vjs-volume-panel-horizontal .vjs-volume-level:before, .video-js .vjs-volume-panel-horizontal .vjs-volume-control:before {
  content: "";
  font-size: 20px;
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  line-height: 0px;
  border-style: solid;
  border-width: 0 0 1.2em 6em;
  border-color: transparent transparent #0e2f5a transparent;
}
.video-js .vjs-volume-panel-horizontal .vjs-volume-control {
  overflow: hidden;
  height: 3em;
}
.video-js .vjs-volume-panel-horizontal .vjs-volume-bar {
  margin: 0;
  height: 100%;
  background-color: transparent;
}
.video-js .vjs-volume-panel-horizontal .vjs-volume-level {
  overflow: hidden;
  height: 100%;
  background: transparent;
  box-shadow: none;
}
.video-js .vjs-volume-panel-horizontal .vjs-volume-level:before {
  border-color: transparent transparent #e8e8e9 transparent;
}
.cld-video-player-floater {
  position: static;
  transition: all 0.5s ease-out;
  transition-property: bottom, right, left;
}
.cld-video-player-floater .cld-video-player-floater-close {
  display: none;
}
.cld-video-player-floater.cld-video-player-floating {
  position: fixed;
  z-index: 9;
  border: 4px solid #fff;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
}
.cld-video-player-floater.cld-video-player-floating .cld-video-player-floater-inner {
  height: 0;
  width: 100%;
}
.cld-video-player-floater.cld-video-player-floating .cld-video-player-floater-close {
  position: absolute;
  bottom: 100%;
  background: #fff;
  border-bottom: none;
  margin-bottom: 4px;
  right: -4px;
  padding: 4px 6px 2px;
  display: block;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.05);
  cursor: pointer;
}
.cld-video-player-floater.cld-video-player-floating .cld-video-player-floater-close::after {
  content: "";
  position: absolute;
  top: 100%;
  right: 0;
  width: 120%;
  height: 4px;
  background: #fff;
}
.cld-video-player-floater.cld-video-player-floating .vjs-time-control,
.cld-video-player-floater.cld-video-player-floating .vjs-upcoming-video-title-display,
.cld-video-player-floater.cld-video-player-floating .vjs-recommendations-overlay {
  display: none;
}
.cld-video-player-floater.cld-video-player-floating .vjs-upcoming-video .vjs-upcoming-video-bar {
  background-color: transparent;
}
.cld-video-player-floater.cld-video-player-floating .vjs-big-play-button {
  font-size: 4em;
  top: 40%;
}
.cld-video-player-floater.cld-video-player-floating.cld-video-player-floater-bottom-right {
  bottom: 20px !important;
  right: 20px !important;
  top: auto !important;
  left: auto !important;
}
.cld-video-player-floater.cld-video-player-floating.cld-video-player-floater-bottom-left {
  bottom: 20px !important;
  left: 20px !important;
  top: auto !important;
  right: auto !important;
}
.vjs-context-menu-ui {
  position: absolute;
  z-index: 2;
}
.vjs-context-menu-ui .vjs-menu-content {
  background: rgba(0, 0, 0, 0.6);
  border-radius: 0.2em;
  padding: 0;
}
.vjs-context-menu-ui .vjs-menu-item {
  font-size: 1em;
  line-height: 1em;
  text-transform: none;
  cursor: pointer;
  margin: 0;
  padding: 0.8em 1.4em;
}
.vjs-context-menu-ui .vjs-menu-item:active, .vjs-context-menu-ui .vjs-menu-item:hover {
  background-color: rgba(0, 0, 0, 0.5);
}
.vjs-context-menu-ui .player-version {
  font-size: 80%;
  opacity: 0.7;
}
.vjs-upcoming-video {
  opacity: 0;
  transition: bottom 0.1s, visibility 0.4s, opacity 0.4s;
  visibility: hidden;
  position: absolute;
  bottom: 4.5em;
  right: 0.75em;
  width: 38.7%;
  max-width: 30em;
  border: 1px solid #E8E8E9;
}
.vjs-upcoming-video:before {
  display: block;
  content: "";
  width: 100%;
  padding-top: 56.25%;
}
.vjs-upcoming-video > .aspect-ratio-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.vjs-upcoming-video .aspect-ratio-content {
  background-size: cover;
}
.vjs-upcoming-video .aspect-ratio-content .vjs-upcoming-video-bar {
  display: flex;
  flex: auto;
  justify-content: space-between;
  position: absolute;
  height: 3em;
  line-height: 3em;
  width: 100%;
  bottom: 0px;
}
.vjs-upcoming-video .aspect-ratio-content .vjs-upcoming-video-bar .vjs-upcoming-video-title {
  flex: auto;
  text-align: left;
  display: block;
  width: auto;
  max-width: 80%;
  padding-left: 1em;
  padding-right: 1em;
}
.vjs-upcoming-video .aspect-ratio-content .vjs-upcoming-video-bar .vjs-upcoming-video-title .vjs-upcoming-video-title-display {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.vjs-upcoming-video .aspect-ratio-content .vjs-upcoming-video-bar .vjs-upcoming-video-title .vjs-upcoming-video-title-display .vjs-upcoming-video-title-display-label {
  font-weight: 400;
}
.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-upcoming-video {
  transition: bottom 1s, visibility 0.4s, opacity 0.4s;
  bottom: 0.7em;
}
.vjs-upcoming-video.vjs-upcoming-video-show {
  transition: visibility 0.4s, opacity 0.4s;
  opacity: 1;
  visibility: visible;
}
.vjs-upcoming-video.disable-transition {
  transition: visibility 0s;
}
@media only screen and (max-width: 768px) {
  .vjs-upcoming-video:before {
    display: none;
  }
  .cld-video-player.cld-video-player-skin-dark .vjs-upcoming-video, .cld-video-player.cld-video-player-skin-light .vjs-upcoming-video {
    border: none;
  }
  .vjs-upcoming-video .aspect-ratio-content {
    background-image: none !important;
  }
}
.vjs-vtt-thumbnail-display {
  position: absolute;
  left: 0;
  bottom: 15px;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.2s;
  bottom: 3em;
  pointer-events: none;
  border: 3px solid #fff;
  border-radius: 3px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
}

.vjs-vtt-time-display {
  position: absolute;
  bottom: -1.7em;
  left: 0;
  right: 0;
  margin: auto;
  color: #fff;
  text-shadow: 0 0 3px #000;
}

.vjs-vtt-thumbnails .vjs-time-tooltip {
  display: none !important;
}
`;

export default CloudinaryVideoPlayerGlobalStyle;
